var React = require('react');

function Playbutton (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0.121094 19C0.121094 8.50659 8.62768 0 19.1211 0C29.6145 0 38.1211 8.50659 38.1211 19C38.1211 29.4934 29.6145 38 19.1211 38C8.62768 38 0.121094 29.4934 0.121094 19Z","key":0}),React.createElement("path",{"d":"M24.6211 19L15.6211 25L15.6211 13L24.6211 19Z","fill":"white","stroke":"white","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Playbutton.defaultProps = {"width":"39","height":"38","viewBox":"0 0 39 38","fill":"#9253A1"};

module.exports = Playbutton;

Playbutton.default = Playbutton;
